import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseCampoComEditComponent } from '../base-campo-com-edit/base-campo-com-edit.component';

@Component({
  selector: 'app-campo-contrato',
  templateUrl: './campo-contrato.component.html',
  styleUrls: ['../base-campo-com-edit/base-campo-com-edit.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: BaseCampoComEditComponent, useExisting: CampoContratoComponent }],
})
export class CampoContratoComponent extends BaseCampoComEditComponent implements OnInit {
  ngOnInit() {
    this.nome = 'Contrato';
    this.prefixo = 'contrato';
    this.formControl = new FormControl(null, this.requireMatch());
  }
}
